var internet = {};
module['exports'] = internet;
internet.domain_suffix = require("./domain_suffix");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/vi/internet/index.js
 ** module id = 1084
 ** module chunks = 0
 **/